export const SET_LOADER = 'setLoader';
export const REMOVE_LOADER = 'removeLoader';

export const HIDE_ERRORS = 'hideErrors';
export const HIDE_WARNINGS = 'hideWarnings';

export const SHOW_REMOVED_CAMPAIGNS = 'showRemovedCampaigns';
export const SHOW_REMOVED_ADS = 'showRemovedAds';
